import Axios from '../baseApi'

export default {
  async create(form) {
    return await Axios.put('/api-master-data/v1/accounting', form);
  },
  async get(id) {
    return await Axios.get(`/api-master-data/v1/accounting/${id}`);
  },
  async upsertBookingAccount(form) {
    return await Axios.post(`/api-master-data/v1/finance/booking-account/`, form);
  },
  async getBookingAccounts() {
    return await Axios.get(`/api-master-data/v1/finance/booking-account/`);
  },
  async getBookingAccount(context, id) {
    return await Axios.get(`/api-master-data/v1/finance/booking-account/${context}/${id}`);
  },
  async updateBookingAccount(form) {
    return await Axios.post(`/api-master-data/booking-account/v1/`, form);
  }
}
